'use client';

export function TivitOrb() {
  return (
    <div className="relative w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 animate-float">
      {/* Outer glow */}
      <div className="absolute inset-0 rounded-full bg-shield-cyan/10 blur-3xl" />

      {/* Second glow ring */}
      <div className="absolute inset-4 rounded-full bg-shield-cyan/5 blur-2xl animate-pulse-glow" />

      {/* Main orb body */}
      <div className="absolute inset-8 rounded-full bg-gradient-to-br from-navy-light to-background border border-shield-cyan/30 shadow-2xl shadow-shield-cyan/20">
        {/* Glass reflection */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-shield-cyan/20 via-transparent to-transparent" />

        {/* Inner core */}
        <div className="absolute inset-12 rounded-full bg-gradient-to-br from-shield-cyan/30 to-shield-cyan/10 border border-shield-cyan/20">
          {/* Central light */}
          <div className="absolute inset-8 rounded-full bg-shield-cyan/40 blur-md animate-pulse-glow" />
          <div className="absolute inset-10 rounded-full bg-shield-cyan/60" />
        </div>

        {/* Subtle scan lines */}
        <div className="absolute inset-0 rounded-full overflow-hidden opacity-30">
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="absolute w-full h-px bg-shield-cyan/40"
              style={{ top: `${(i + 1) * 12}%` }}
            />
          ))}
        </div>
      </div>

      {/* Orbiting particle */}
      <div className="absolute top-1/2 left-1/2 w-2 h-2 -translate-x-1/2 -translate-y-1/2">
        <div
          className="absolute w-2 h-2 rounded-full bg-shield-cyan shadow-lg shadow-shield-cyan/50"
          style={{
            animation: 'orbit 8s linear infinite',
            transformOrigin: '0 -120px',
          }}
        />
      </div>

      <style jsx>{`
        @keyframes orbit {
          from { transform: rotate(0deg) translateY(-120px); }
          to { transform: rotate(360deg) translateY(-120px); }
        }
      `}</style>
    </div>
  )
}
